import { getPageOrder, reorderPagesAtInsertPoint } from './webDataPageOrder';

function orderBySortIndex(staticPages, keys) {
  return [...keys].sort((a, b) => {
    const ai = staticPages[a]?.sortIndex;
    const bi = staticPages[b]?.sortIndex;
    if (typeof ai === 'number' && typeof bi === 'number') return ai - bi;
    if (typeof ai === 'number') return -1;
    if (typeof bi === 'number') return 1;
    return 0;
  });
}

/** Ordre des pages statiques du template (sidebar + génération site). */
export function getStaticPageOrder(staticPages, storedOrder) {
  const pages = staticPages || {};
  const keys = Object.keys(pages).filter((k) => pages[k] && typeof pages[k] === 'object');

  if (Array.isArray(storedOrder) && storedOrder.length) {
    return getPageOrder({ pages, pageOrder: storedOrder });
  }

  const hasSortIndex = keys.some((k) => typeof pages[k].sortIndex === 'number');
  if (hasSortIndex) {
    return orderBySortIndex(pages, keys);
  }

  return keys;
}

export function reorderStaticPages(order, fromSlug, insertBeforeIndex) {
  return reorderPagesAtInsertPoint(order, fromSlug, insertBeforeIndex);
}

/** Objet static_pages avec clés dans l'ordre voulu (meilleure compat JSON). */
export function buildOrderedStaticPages(staticPages, order) {
  const resolved = getStaticPageOrder(staticPages, order);
  return Object.fromEntries(
    resolved
      .filter((slug) => staticPages?.[slug])
      .map((slug, idx) => [
        slug,
        { ...staticPages[slug], sortIndex: idx },
      ]),
  );
}

/**
 * Aligne pageOrder du site sur l'ordre des pages statiques du template.
 * Les pages proposal et les statiques utilisateur conservent leur position relative.
 */
export function syncWebDataStaticPageOrder(webData, template) {
  if (!webData?.pages || !template?.static_pages) return webData;

  const templateOrder = getStaticPageOrder(
    template.static_pages,
    template.static_page_order,
  );
  const templateStaticInWeb = templateOrder.filter(
    (slug) => webData.pages[slug]?.type === 'static',
  );
  if (!templateStaticInWeb.length) return webData;

  const currentOrder = getPageOrder(webData);
  const templateStaticSet = new Set(templateOrder);
  const extraStatics = currentOrder.filter(
    (slug) => webData.pages[slug]?.type === 'static' && !templateStaticSet.has(slug),
  );
  const nonStatics = currentOrder.filter(
    (slug) => webData.pages[slug]?.type !== 'static',
  );
  const newOrder = [...templateStaticInWeb, ...extraStatics, ...nonStatics];
  const missing = Object.keys(webData.pages).filter((slug) => !newOrder.includes(slug));
  if (missing.length) newOrder.push(...missing);

  if (newOrder.join('|') === currentOrder.join('|')) return webData;
  return { ...webData, pageOrder: newOrder };
}
